// Opening a file (a PDF, a statement, a receipt, a photo) the reader can get
// back from.
//
// window.open(url, "_blank") is fine in a desktop browser: a new tab, close
// it when done. On a phone running the installed app it is not: there is no
// tab bar and no back gesture for a page opened that way, so a court form
// opened from the Evictions page became a dead end (Sahil, 2026-10-06). So
// on a phone, or whenever the app runs installed (standalone), the file
// opens in the app's own full-screen viewer (FileViewer.js: Close button,
// the phone's back button, "Open in browser" for the few who want it); on
// a desktop browser it still opens in a new tab.
export const FILE_OPEN_EVENT = "housify:open-file";

export function opensInApp() {
  try {
    const mm = (q) => (typeof window.matchMedia === "function" ? window.matchMedia(q).matches : false);
    const standalone = mm("(display-mode: standalone)") || mm("(display-mode: fullscreen)") || window.navigator.standalone === true;
    const phone = mm("(pointer: coarse)") && Math.min(window.innerWidth, window.innerHeight) < 900;
    return standalone || phone;
  } catch (_e) { return false; }
}

/** Open a file URL: the in-app viewer on phones / installed, a new tab elsewhere. */
export function openFile(url, { title = "" } = {}) {
  if (!url) return;
  if (opensInApp()) {
    window.dispatchEvent(new CustomEvent(FILE_OPEN_EVENT, { detail: { url, title } }));
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
